import { isNil, isEmpty, both, complement } from 'ramda'

export const isNotNilOrEmpty = both(complement(isNil), complement(isEmpty))
